export type PriceValue = {
  value: number
  currency: string
}

export type DateRange = {
  from: Date
  to: Date
}

export type Value = number | string | Date | PriceValue | DateRange

export type BreakdownValue = {
  value: Value
  breakdown: {
    title: string
    items: {
      label: string
      value: Value
    }[]
  }
}

export type AnalyticsTableCellValue =
  | Value
  | BreakdownValue
  | [Value | BreakdownValue, Value | BreakdownValue]

export const isBreakdownValue = (value: Value | BreakdownValue): value is BreakdownValue =>
  typeof value === 'object' && value !== null && 'breakdown' in value

export const isValuePair = (
  value: Value | BreakdownValue | [Value | BreakdownValue, Value | BreakdownValue],
): value is [Value | BreakdownValue, Value | BreakdownValue] =>
  Array.isArray(value) && value.length === 2
